import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { StorageService } from './StorageService';
import { SpinnerService } from '../spinner/spinner.service';
import 'rxjs/add/operator/do';
import { tap } from 'rxjs/operators';
import { Router } from '@angular/router';
import { MessageModel } from '../../model/models';
import { CurrentPageWatcherService } from '../utils/CurrentPageWatcher';
import * as $ from 'jquery';


@Injectable()
export class JwtIntereptorService implements HttpInterceptor {

  userMessages: Array<MessageModel> = [];


    constructor( private selfSpinner: SpinnerService,
                private storageService: StorageService, 
                private router: Router,
                private currentPageWatcher : CurrentPageWatcherService) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        // add authorization header with jwt token if available
            this.selfSpinner.show();
            let userSessionId = this.storageService.getSessionData().userSessionId;
            let token = this.storageService.getSessionData().token;

            if (userSessionId && token) {
                request = request.clone({
                    setHeaders: {
                        Authorization: `Bearer ${token}`
                    }
                });
            }

            return next.handle(request).do(event => {
              if(event.type){
                this.selfSpinner.hide();
            }                
             }).pipe( tap(() => {},
             (err: any) => {
             if (err instanceof HttpErrorResponse) {
               if (err.status !== 401 && err.status !== 404) {
                 this.handleEmployeesError(err);
                return;
               }
               if (err.status == 401 ){
               this.router.navigate(['/login']).then(()=>{this.selfSpinner.hide()});
              }
             }
           }));;
        }
        handleEmployeesError(err) {

          if (err.error && err.error.UserMessages != undefined) {
            err.error.UserMessages.forEach(element => {
              this.userMessages.push(element)
            });
          }
          else {
            let userMsg: MessageModel = new MessageModel;
            userMsg.Alert = 3;
            userMsg.Description = err.message;
            this.userMessages.push(userMsg);
          }
          $("html, body").animate({ scrollTop: 0 }, "slow");
          this.currentPageWatcher.sendUserMessages(this.userMessages);
          this.selfSpinner.hide();
          this.userMessages=[];
        } 
}



// WEBPACK FOOTER //
// ./src/app/shared/security/jwt-intereptor.service.ts